export function capitalCase(text) {
  const words       = text.split(' ');
  const capitalized = words.map(capitalizeWord);
  return capitalized.join(' ');
}

function capitalizeWord(word) {
  return word[0].toUpperCase() + word.substr(1);
}
